import { Component, Input, OnInit } from '@angular/core';
import { FooterTop } from '../_models/footer.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer-top',
  templateUrl: './footer-top.component.html',
  styleUrls: ['./footer-top.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule]
})
export class FooterTopComponent implements OnInit {
  @Input() content: FooterTop;
  constructor() { }

  ngOnInit() { }
}
